import { makeToast as beaconMakeToast } from "@braze/beacon-core";

import { logFullstoryEvent } from "@lib/logFullstoryEvent";

import { brazeToasterId } from "./constants";
import type { ToastContent, ToastIntent, ToastOptions } from "./types";

/**
 * Send a toast message
 *
 * See https://beacon-storybook.braze.com/?path=/docs/core-alerts-toaster--basic-use#maketoast for full documentation
 * @param intent one of `"danger"`, `"info"`, `"success"`, or `"warning"`
 * @param content a string, or a React component
 * @param options makeToast options
 * @returns
 */
export const makeToast = (
  intent: ToastIntent,
  content: ToastContent,
  { containerId = brazeToasterId, ...options }: ToastOptions = {}
) => {
  if (intent === "danger" || intent === "warning") {
    logFullstoryEvent("toast", { intent, content });
  }
  return beaconMakeToast(intent, content, {
    containerId,
    ...options,
  });
};
